import React from 'react';
import logo from '../images/logo.png';
import styles from './CSS/Logo.module.css'


function Logo() {
  const reloadPage = () => {
    window.location.reload();
  }


  return (
    <div className={styles.logo} onClick={reloadPage}>
        <img src={logo} alt="logo"/>
        <h1>pairedactors</h1>
    </div>
  )
}

export default Logo